/* global swal, moment */
import modalTemplate from 'modals/marketplace/template.html';
import modalController from 'modals/marketplace/controller';
import { chunk, get } from 'lodash';
import './style.less';

//TODO: Calendar view needs to be added
export default function($q, $log, $uibModal, $filter, $state, $stateParams, EventClass, ProfileClass) {
  'ngInject';

  $log.debug('Events Component Activated');
  const vm = this;
  vm.$onChanges = activate;

  const { company_id } = ProfileClass;
  const removeOwnEvents = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.removeOwnEvents');

  vm.pageTitle = vm.pageTitle || 'Events';
  vm.dataCollection = [];

  vm.openEvent = (event, location) => {
    $uibModal
      .open({
        template: modalTemplate,
        controller: modalController(event, location),
        size: 'lg',
        backdrop: true
      })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  };

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  function applyStockImages() {
    vm.events.forEach(event => {
      const num = getRandomInt(0, 40);

      if (event.productImageUrl) return;

      event.productImageUrl = `https://assets.prolaera.com/img/stock-images/stock-image-${num}.jpg`;
    });
  }

  function tableClean(events) {
    return events.map(event => {
      const { name, course_name, passes, price, priceText, subject } = event || {};

      event.name = name || subject || course_name;

      if (passes && passes.length) {
        event.priceText = `Included in ${passes.map(({ productName }) => productName).join(', ')}`;
      } else {
        event.priceText = priceText || $filter('currency')(price || 0);
      }

      const { waitlist, full } = EventClass.getWaitlist(event, vm.locationOverride);

      event.full = full;
      event.waitlist = waitlist;

      return event;
    });
  }

  function activate() {
    try {
      $log.debug('Marketplace Cards Component Updated');
      vm.loaded = false;
      vm.pagination = {
        pageSize: vm.pageSize || 10,
        page: $stateParams.page || 1,
        showPage: 0,
        setPage: pageNo => {
          vm.pagination.page = pageNo;
          vm.pagination.showPage = pageNo - 1;
        }
      };

      if (!vm.events) return;

      tableClean(vm.events);

      if (removeOwnEvents) {
        vm.events = vm.events.filter(({company_id: course_company_id, vendor_id}) => course_company_id != company_id && vendor_id != company_id);
      }

      applyStockImages();

      vm.baseUrl = $state.$current.includes['app.users.dashboard'] ? 'app.events' : undefined;
      vm.pages = chunk(vm.events, vm.pagination.pageSize);

      vm.loaded = true;
    } catch (e) {
      vm.loaded = true;
      vm.error = true;
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplaceCards/controller.js